import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../../constants/react_app_consts";

const initialState = {
 retrieve_specific_grn_schedule_details: { status: "idle" },
};

export const retrieve_specific_grn_schedule_details_Slice = createSlice({
 name: "retrieve_specific_grn_schedule_details",
 initialState,
 reducers: {
  success_retrieve_specific_grn_schedule_details: (state, action) => {
   state.retrieve_specific_grn_schedule_details = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_specific_grn_schedule_details: (state, action) => {
   state.retrieve_specific_grn_schedule_details = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_specific_grn_schedule_details: (state) => {
   state.retrieve_specific_grn_schedule_details = { status: app_consts.IDLE };
  },
  loading_retrieve_specific_grn_schedule_details: (state) => {
   state.retrieve_specific_grn_schedule_details = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_specific_grn_schedule_details, fail_retrieve_specific_grn_schedule_details, reset_retrieve_specific_grn_schedule_details, loading_retrieve_specific_grn_schedule_details } = retrieve_specific_grn_schedule_details_Slice.actions;

export default retrieve_specific_grn_schedule_details_Slice.reducer;